import { instance } from "apis/interceptor";

type ResponseType<T> = {
  success: boolean;
  statusCode?: number;
  message?: string;
  data?: T;
};

export type TComplainCategory = {
  id?: string;
  content?: string;
};

//FEAT: (new) 민원 종류 조회하기
export const getComplainCategories = async (): Promise<ResponseType<TComplainCategory[]>> => {
  try {
    const res = await instance.get("/meeting-room-complain/category");
    return { success: true, data: res.data };
  } catch (error: any) {
    return { success: false, message: error ?? "" };
  }
};

//FEAT: (new) 민원 종류 설정하기
export const  updateComplainCategories = async (categories: string[]): Promise<ResponseType<TComplainCategory[]>> => {
  try {
    const res = await instance.patch("/meeting-room-complain/category", {
      complainCategoryList: categories
    });
    return { success: true };
  } catch (error: any) {
    return { success: false, message: "처리 중 오류가 발생했습니다. 다시 시도해 주세요." };
  }
};
